// extracted by mini-css-extract-plugin
export default {"icon":"Auth_icon__OqQ3K","active":"Auth_active__LCeyF"};